module.exports = __webpack_public_path__ + "img/jeff-team-buff.e1d1a3e5.png";